import React from "react";
import { Router, Route, Redirect } from "react-router";
import appPath from "../utils/appPath";
import AccountManagementLayout from "../containers/AccountManagementLayout";
import DefaultLayout from "../containers/DefaultLayout";
import FullWidthLayout from "../containers/FullWidthLayout";
import PageNotFound from "../components/page-not-found/PageNotFound";
import SubscriptionsContainer from "../containers/v2/SubscriptionsContainer";
import RevalidateBefore from "../containers/v3/RevalidateBeforeContainer";
import VerifyBulkSubscriptionContainer from "../containers/v2/bulk-subscriptions/VerifyBulkSubscriptionContainer";
import LayoutContainerV3 from "../containers/v3/LayoutContainer";
import LayoutV3 from "../components/v3/layout/Layout";
import ScreenContainer from "../components/v3/screen-container/ScreenContainer";
import RegistrationSignInContainerV3 from "../containers/v3/RegistrationSignInContainer";
import RegistrationSignInComponentV3 from "../components/v3/registration-sign-in/RegistrationSignIn";
import RegistrationContainerV3 from "../containers/v3/RegistrationContainer";
import RegisterSwapper from "../components/v4/register/RegisterSwapper";
import RegisterSwappingContainer from "../containers/v4/RegisterSwappingContainer";
import ActivationEmailContainerV3 from "../containers/v3/ActivationEmailContainer";
import ActivationEmailComponentV3 from "../components/v3/activation-email/ActivationEmail";
import ForgotPasswordContainerV3 from "../containers/v3/ForgotPasswordContainer";
import ForgotPasswordComponentV3 from "../components/v3/forgot-password/ForgotPassword";
import SetPasswordContainerV3 from "../containers/v3/SetPasswordContainer";
import ProfessionContainerV3 from "../containers/v3/ProfessionContainer";
import ProfessionComponentV3 from "../components/v3/profession/Profession";
import SignupNewslettersContainerV3 from "../containers/v3/SignupNewslettersContainer";
import ManageSubscriptionContainer from "../containers/v3/ManageSubscriptionContainer";
import EmailResentContainer from "../containers/v3/EmailResentContainer";
import EmailResentComponentV3 from "../components/v3/email-resent/EmailResent";
import SetPasswordComponentV3 from "../components/v3/set-password/SetPassword";
import SignupNewslettersComponentV3 from "../components/v3/signup-newsletters/SignupNewsletters";
import BusinessweekRegisterComponentV3 from "../components/v3/businessweek-register/BusinessweekRegister";
import WithInactivityTimeout from "../containers/v3/WithInactivityTimeout";
import SubscriptionActivationEmailComponent from "../components/v3/subscription-activation-email/SubscriptionActivationEmail";
import StudentDocumentUploadContainer from "../containers/v3/StudentDocumentUploadContainer";
import StandaloneNewsletter from "../containers/v3/StandaloneNewsletterContainer";
import { isOnboardingEnabled } from "../utils/FeatureFlags";
import {
    AppleNewsSocial,
    TerminalSignIn,
    NewsletterRedesign,
    Watchlist,
    Magazines,
    LinkSubscription,
    OffersContainer,
    OfferSuccessContainer,
    SubscriptionFormContainer,
    SubscriptionSuccessContainer,
    Account,
    BulkSubscriptionFormContainer,
    CounterOffersContainer,
    OnboardingContainer
} from "./dynamicImportComponents";

const routes = (history) => {
    /* [SC] 07/23/2019 when using a basePath in react-router v3, there's a strange behavior
     *      where it can't exact match the basePath route (in this case '/account') in the normal
     *      route block using that path. To get around this, I added a block in front that
     *      explicitly matches the basePath and points to /account/signin, to circumvent the problem.
     */

    return (
        <Router history={ history }>
            <Route>
                <Redirect from={ appPath.withoutQuery() } to={ appPath.withoutQuery("/signin") } />
            </Route>
            <Route path={ appPath.withoutQuery() } component={ DefaultLayout }>
                <Redirect from="magazine" to="businessweek-register" />
                <Redirect from="iframe/magazine" to="iframe/businessweek-register" />
                <Redirect from="iframe/password/forgot" to="iframe/forgot-password" />
                <Redirect from="password/forgot" to="forgot-password" />
                <Redirect from="password/reset" to="reset-password" />
                <Redirect from="industry" to="profession" />
                <Redirect from="iframe/industry" to="iframe/profession" />

                <Route path="iframe/apple-news-social" component={ AppleNewsSocial } />
                <Route path="iframe/terminal-signin" component={ TerminalSignIn } />

                <Route path="apple-news-social" component={ AppleNewsSocial } />
                <Route path="terminal-signin" component={ TerminalSignIn } />

                <Route path="newsletters" component={ NewsletterRedesign } />

                <Route component={ WithInactivityTimeout(AccountManagementLayout) }>
                    <Redirect from="account" to="settings" />

                    <Route path="settings" component={ Account } />
                    <Route path="watchlist" component={ Watchlist } />
                    <Route path="magazines" component={ Magazines } />
                    <Route path="subscriptions" component={ RevalidateSubscriptions } />

                    <Route path="offers" component={ OffersContainer } />
                    <Route path="offer-success" component={ OfferSuccessContainer } />

                    <Route path="businessweek" component={ LinkSubscription } />
                </Route>

                { V3SubscriptionsRoutes() }
                { V3Routes() }

                { BulkSubsRoutes() }

                <Route component={ FullWidthLayout }>
                    <Route path="*" component={ PageNotFound } />
                </Route>
            </Route>
            <Route>
                <Redirect from="*" to={ appPath.withoutQuery("/signin") } />
            </Route>
        </Router>
    );
};

function V3Routes() {
    return (
        <Route>
            <Redirect from="/" to="signin" />
            <Redirect from="signup" to="signin" />
            <Redirect from="create-acct" to="register" />
            <Redirect from="iframe/login" to="iframe/signin" />
            <Redirect from="login" to="signin" />
            <Redirect from="register-businessweek" to="businessweek-register" />

            <Route path="iframe/signin" component={ RegistrationSignInContainerV3(ScreenContainer(RegistrationSignInComponentV3, { hasMultipleScreens: false })) } />
            <Route path="iframe/register" component={ RegisterSwappingContainer(RegisterSwapper) } />
            <Route path="iframe/activation-email" component={ ActivationEmailContainerV3(ScreenContainer(ActivationEmailComponentV3, { hasMultipleScreens: false })) } />
            <Route path="iframe/forgot-password" component={ ForgotPasswordContainerV3(ScreenContainer(ForgotPasswordComponentV3, { hasMultipleScreens: false })) } />
            <Route path="iframe/profession" component={ ProfessionContainerV3(ScreenContainer(ProfessionComponentV3, { hasMultipleScreens: false })) } />
            <Route path="iframe/email-resent" component={ EmailResentContainer(ScreenContainer(EmailResentComponentV3, { hasMultipleScreens: false })) } />
            <Route path="iframe/businessweek-register" component={ RegistrationContainerV3(ScreenContainer(BusinessweekRegisterComponentV3, { hasMultipleScreens: false })) } />

            <Route component={ LayoutContainerV3(LayoutV3) }>
                <Route path="expired-token" component={ VerifyBulkSubscriptionContainer } />
                <Route path="signin" component={ RegistrationSignInContainerV3(ScreenContainer(RegistrationSignInComponentV3, { hasMultipleScreens: false })) } />
                <Route path="register" component={ RegisterSwappingContainer(RegisterSwapper) } />
                <Route path="businessweek-register" component={ RegistrationContainerV3(ScreenContainer(BusinessweekRegisterComponentV3, { hasMultipleScreens: false })) } />
                <Route path="activation-email" component={ ActivationEmailContainerV3(ScreenContainer(ActivationEmailComponentV3, { hasMultipleScreens: false })) } />
                <Route path="forgot-password" component={ ForgotPasswordContainerV3(ScreenContainer(ForgotPasswordComponentV3, { hasMultipleScreens: false })) } />
                <Route path="reset-password" component={ SetPasswordContainerV3(ScreenContainer(SetPasswordComponentV3, { hasMultipleScreens: false })) } />
                <Route path="set-password" component={ SetPasswordContainerV3(ScreenContainer(SetPasswordComponentV3, { hasMultipleScreens: false })) } />
                <Route path="profession" component={ ProfessionContainerV3(ScreenContainer(ProfessionComponentV3, { hasMultipleScreens: false })) } />
                <Route path="signup-newsletters" component={ SignupNewslettersContainerV3(ScreenContainer(SignupNewslettersComponentV3, { hasMultipleScreens: true })) } />
                <Route path="email-resent" component={ EmailResentContainer(ScreenContainer(EmailResentComponentV3, { hasMultipleScreens: false })) } />
                <Route path="student-document-upload" component={ StudentDocumentUploadContainer } />
                <Route path="newsletters/:newsletterListId" component={ StandaloneNewsletter } />

                { isOnboardingEnabled() && (
                    <Route path="onboarding" component={ OnboardingContainer } />
                ) }
            </Route>
        </Route>
    );
}

const RevalidateSubscriptions = (props) => {
    return (
        <RevalidateBefore { ...props }>
            <SubscriptionsContainer { ...props } />
        </RevalidateBefore>
    );
};

function V3SubscriptionsRoutes() {
    return (
        <Route component={ LayoutContainerV3(LayoutV3) }>
            <Route path="subscription-form" component={ SubscriptionFormContainer } />
            <Route path="subscription-success" component={ SubscriptionSuccessContainer } />
            <Route path="subscription-activation-email" component={ ActivationEmailContainerV3(SubscriptionActivationEmailComponent) } />
            <Route path="group-subscription-purchase-form" component={ BulkSubscriptionFormContainer } />
            <Route path="full-price-offers" component={ CounterOffersContainer } />
        </Route>
    );
}

function BulkSubsRoutes() {
    return (
        <Route component={ LayoutContainerV3(LayoutV3) }>
            <Route path="manage-subscription" component={ WithInactivityTimeout(ManageSubscriptionContainer) } />
        </Route>
    );
}

export default routes;
